import axios from "axios";

export const CurrentUser = {
    namespaced: true,

    state: {
        role: '',
        fio: '',
        fioInitials: '',
        email: '',
        login: '',
        permissions: [],
    },

    mutations: {
        setUserOptions (state, data) {
            Object.assign(state, data);
        },
    },

    actions: {
        fetch: async function ({ state, commit }) {
            //TODO подумать как сделать лучше
            //получаем объект юзера по пути
            let route = window.location.pathname.match(/^\/(.*?)\//);
            if (!route) {
                commit('setUserOptions', {
                    role: 'guest',
                    fio: '',
                    fioInitials: '',
                    email: '',
                    login: '',
                    permissions: [],
                });
            } else {
                axios.get(`/${route[1]}/user`).then(response => {
                    commit('setUserOptions', response.data);
                });
            }
        },
    },
    getters: {
        hasPermission: state => permission => {
            return state.permissions.includes(permission);
        }
    }
};
